import { ActiveRecord, sources } from '@mysidewalk/active-record';
import TimeContextType from './TimeContextType.js';
/**
 * @memberof system-metadata
 * @classdesc
 * TimeElements represent a single unit of time, where the unit can range from a
 * single custom fiscal year to a single standard calendar year. TimeElements
 * can also be days, minutes, or any other name for a given time period (does
 * not need to be recurring). e.g. "2001", "2014", "FY2017-18", etc.
 *
 * Each TimeElement belongs to a TimeGroup, where the group defines the class of
 * units; e.g. "Calendar Years", "Days of the week", "Months of the year", etc.
 *
 * @property {number} id
 * @property {string} friendlyLongName
 * @property {string} friendlyShortName
 * @property {number} normalizerYear
 * @property {system-metadata.TimeGroup} timeGroup
 * @property {system-metadata.TimeContextType} contextType
 * @property {string} systemName
 * @property {number} order
 * @property {system-metadata.Attribution} attribution
 * @property {boolean} isTimeDelta
 * @property {date} publishedDate
 */
class TimeElement extends ActiveRecord {
    get isHistorical() {
        return this.contextType === TimeContextType.HISTORICAL;
    }
    get isProjection() {
        return this.contextType === TimeContextType.PROJECTION;
    }
    get isOfficial() {
        return this.contextType === TimeContextType.OFFICIAL;
    }
    get isCurrent() {
        return this.isOfficial || this.contextType === TimeContextType.CURRENT;
    }
}
TimeElement.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default TimeElement;
